import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import Layout from '../components/complex/layout';
import UsersSearchBar from './users/usersSearchBar';
import UsersList from './users/usersList';
import ModalComponent from '../components/complex/modalComponent';
import NewUserForm from './users/newUserForm';

class Users extends PureComponent {
  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onSearch = (keyword) => {
    this.setState({keyword: keyword});
  }
  
  onUsersListRender = () => {
    this.usersList.onAccept();
  }

  onUpdateSearch = () => {
    this.usersSearchBar.resetKeyWordInput();
  }

  state = {
    isActive: false,
    keyword: null,
    body: <NewUserForm
      onClose={this.onToggleModal}
      onAccept={this.onUsersListRender}
    />,
  }

  render() {
    const {
      isActive,
      body,
    } = this.state;

    return (
      <Layout>
        <h1 className="main-title">Users</h1>
        <Row>
          <Col sm={12}>
            <div className="text-right">
              <div
                className="edit-link"
              >
                <span
                  onClick={this.onToggleModal}
                  className="new-link-btn"
                >
                  Add User
                </span>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <UsersSearchBar 
              onSearch={this.onSearch.bind(this)}
              onRef={ref => (this.usersSearchBar = ref)} 
            />
            <UsersList
              updateSearchBar={this.onUpdateSearch}
              keyword={this.state.keyword}
              onRef={ref => (this.usersList = ref)} 
            />
          </Col>
        </Row>
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title="Add User"
          body={body}
        />
      </Layout>
    );
  }
}

export default Users;


// WEBPACK FOOTER //
// ./src/app/screens/users.js